import { ConfigurationService as CheckoutConfigurationService } from '@bytel/checkout';

import { ConfigurationService } from '../common/services/configuration.service';

type returnBooleanPromise = () => Promise<boolean>;

export const initializeProvider =
    (config: ConfigurationService, checkoutConfig: CheckoutConfigurationService): returnBooleanPromise =>
    (): Promise<boolean> =>
        new Promise<boolean>((resolve) => {
            checkoutConfig.initialize(config.getData()?.global).subscribe({
                next: () => {
                    resolve(true);
                },
                error: (e) => {
                    console.error(e);
                    return resolve(false);
                },
            });
        });
